import { GenerateDefaultTemplatesRequestDto } from "../generated/schema.ts";
import { useApiMutation } from "./use-api-mutation";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { invalidateAllWorkflowsV2Key } from "./use-get-all-workflows-v2.ts";

export default function useGenerateTrackingTemplatesAndWorkflows(shopId: string) {
  return useApiMutation(
    "post",
    "/shops/{shopId}/tracking-notification/generate-default-templates",
    {
      notify: false,
      meta: {
        success: {
          title: "templatesEditor.generate.success.title",
          message: "templatesEditor.generate.success.message",
        },
        error: {
          title: "templatesEditor.generate.error.title",
          message: "templatesEditor.generate.error.message",
        },
        invalidatesQuery: [
          invalidateAllShopEmailTemplatesKey(shopId),
          invalidateAllWorkflowsV2Key(shopId),
        ],
      },
      mapVariables: ({ requestBody }: { requestBody: GenerateDefaultTemplatesRequestDto }) => ({
        params: { path: { shopId } },
        body: requestBody,
      }),
    },
  );
}
